import Vue from 'vue'
import Card from './Card'
import Child from './Child'
import Button from './Button'
import Checkbox from './Checkbox'
import Map from './Map'
import { HasError, AlertError, AlertSuccess } from 'vform'
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Components that are registered globaly.
[
  Card,
  Child,
  Button,
  Checkbox,
  HasError,
  AlertError,
  AlertSuccess,
  Map
].forEach(Component => {
  Vue.component(Component.name, Component)
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js